import { Button, Spacer, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import {
  AdminPage,
  AdminPageContent,
  AdminPageHeader,
  AdminPageHeading,
} from '@/components/AdminPage';
import { AdminTopBarNavMenuFrame } from '@/imports/ui/admin/layouts/AdminTopBarNavMenuFrame';
import { useDownloadUserCsvErrors } from '@/imports/ui/hooks/useDownloadErrorFile/useDownloadUserCsvErrors';

import { AdminDeactivatedUserLogsModal } from './components/AdminDeactivatedUserLogsModal';
import { AdminArchivedOrganizationLogsModal } from './components/AdminArchivedOrganizationLogsModal';
import { MembersRecordList } from './MembersRecordList/MembersRecordList';
import { useMembersPagination } from './hooks/useMembersPagination/useMembersPagination';

type IMembersPageProps = {
  archivedOnly?: boolean;
};

export const MembersPage: React.FC<IMembersPageProps> = ({
  archivedOnly = false,
}) => {
  useDownloadUserCsvErrors({
    validRoutes: archivedOnly ? ['archived-users'] : ['people'],
  });
  const useMembersPaginationData = useMembersPagination({ archivedOnly });
  const deactivatedLogsModal = useDisclosure();
  const archivedOrganizationLogsModal = useDisclosure();

  return (
    <AdminTopBarNavMenuFrame>
      <AdminPage maxWidth="container.xl" marginX="auto">
        <AdminPageHeader>
          <AdminPageHeading>
            {archivedOnly ? 'Archived Contacts' : 'Contacts'}
          </AdminPageHeading>
          <Spacer />
        </AdminPageHeader>
        <AdminPageContent>
          <MembersRecordList
            {...useMembersPaginationData}
            onOpenDeactivatedLogs={
              archivedOnly ? deactivatedLogsModal.onOpen : undefined
            }
            onOpenArchivedOrganizationLogs={
              archivedOnly ? archivedOrganizationLogsModal.onOpen : undefined
            }
          />
        </AdminPageContent>
      </AdminPage>
      {archivedOnly && (
        <>
          <AdminDeactivatedUserLogsModal
            isOpen={deactivatedLogsModal.isOpen}
            onClose={deactivatedLogsModal.onClose}
          />
          <AdminArchivedOrganizationLogsModal
            isOpen={archivedOrganizationLogsModal.isOpen}
            onClose={archivedOrganizationLogsModal.onClose}
          />
        </>
      )}
    </AdminTopBarNavMenuFrame>
  );
};
